import React from 'react';
import styled from 'styled-components';
import { colors } from 'styleguide/colors';
import { P2, P4 } from 'styleguide/Texts';
import { themeState } from 'styleguide/theme';
import { View } from 'styleguide/View';
import { CSSProperties } from 'react';

const Container = styled(View)`
  width: 72px;
`;

interface ProfileStatProps {
  label: string;
  count: string;
  onClick?: () => void;
  disabled?: boolean;
  style?: CSSProperties;
}

export const ProfileStat = ({ label, count, onClick, disabled, style }: ProfileStatProps) => {
  const disabledTextProps = disabled
    ? {
        style: {
          color: themeState.current.name === 'light' ? colors.greyHiperDark : colors.greyHiperLight,
        },
      }
    : {};
  return (
    <Container
      onClick={disabled ? undefined : onClick}
      style={{ cursor: !!onClick && !disabled ? 'pointer' : 'default', ...style }}
    >
      <P4 type="secondary">{label}</P4>
      <P2 {...disabledTextProps}>{count}</P2>
    </Container>
  );
};
